import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
    active: false,

    // model
    extraInfoModel: [],

    // 検索
    filters: {
        searchKeyWord: null,
        filterMode:1
    },

    //form
    buttonId: null,
    index: 0,

    // 選択されたファイル情報
    value: null,

    // モーダルに重ねて表示する場合true
    overlay: false,
}

const getters = {
    get: state => state
}

const actions = {
    show ({commit}, { buttonId, index,overlay}) {
        // cover
        this.dispatch('core/showModalCover')
        commit('setButtonId', buttonId)
        if (index !== undefined) {
            commit('setIndex', index)
        }
        if (overlay === undefined || overlay === false) {
            commit('setOverlay', false)
        } else {
            commit('setOverlay', overlay)
            this.dispatch('core/showActiveModalCover')
        }
        commit('showed')
    },
    hide ({commit}) {
        if (!state.active) return
        commit('hided')
        // cover
        setTimeout(() => {
            if (state.overlay){
                this.dispatch('core/hideActiveModalCover')
            }else{
                this.dispatch('core/hideModalCover')
            }
        }, 350)
    },

    /**
     * 初期データを読出し
     */
    loadModel ({commit}, {searchParams}) {
        return new Promise((resolve, reject) => {
            ApiManager.request(
                [
                    'videoChat'
                ],
                [
                    'v1VideoChatApplaunchextrainfoGet'
                ],
                [
                    searchParams
                ])
                .then(res => {
                    let status = Utility.parseResponse(res)

                    if (status.result) {
                        commit('setExtraInfoModel', res[0].data.videoChatAppLaunchExtraInfo)
                        resolve()

                    } else if (status.error) {
                        // エラーメッセージ表示
                        reject(res)
                    } else {
                        // アプリケーションエラー表示
                        reject(null)
                    }
                })
                .catch(error => {
                    // アプリケーションエラー表示
                    reject(null)
                })
        })
    },

    /**
     * 選択されたファイル情報を保持
     */
    setValue ({commit}, data) {
        commit('setValue', data)
    },

    /**
     * リセット
     */
    reset ({commit}) {
        commit('reset')
    }
}

const mutations = {
    showed (state) {
        state.active = true
    },
    hided (state) {
        state.active = false
    },

    // model
    setExtraInfoModel (state, data) {
        Vue.set(state, 'extraInfoModel', data)
    },
    setInputFilter (state, {key, value}) {
        Vue.set(state.filters, key, value)
    },

    // form
    setButtonId (state, id) {
        state.buttonId = id
    },
    setIndex (state, index) {
        state.index = index
    },
    setValue (state, data) {
        Vue.set(state, 'value', data)
    },

    // overlay
    setOverlay (state, flag) {
        state.overlay = flag
        console.log('actions', flag)
    },

    // reset
    reset (state) {
        Vue.set(state, 'extraInfoModel', [])
        Vue.set(state, 'value', null)
        Vue.set(state, 'filters', {
            searchKeyWord: null,
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
